import PersistentStorage from 'notebook/notes/PersistentStorage';
import lazyInit from 'util/lazyInit';

// wks_*** -> STEP_STATE -> SELECTED_STEP -> stepId is overall flow with below interfaces and enums:
// wks_*** to get storage for specific worksheet.

/**
 * WorksheetPersistentStorage provides a PersistentStorage interface for interacting with the browser's
 * underlying local and session storage. Specifically, the worksheet model storate a STEP_STATE keyed against
 * each worksheet API ID. For each STEP_STATE, there is a nested map containing the SELECTED_STEP state that
 * is keyed against the specific stepId.  To get the specific state for a worksheet, you can use
 * `WorksheetPersistentStorage.getStepState(worksheetApiId)` and to set the state, you can use
 * `WorksheetPersistentStorage.setStepState(worksheetApiId, fileStepState)`.
 */

export interface WorksheetStorageStateInterface {
  selectedStepId: string;
}

// WorksheetPersistentStorage calls upon PersistentStorage to manage the session and local storage for worksheets
class WorksheetPersistentStorage extends PersistentStorage<WorksheetStorageStateInterface> {
  getStepState(fileId: string): WorksheetStorageStateInterface | undefined {
    const fileStorage = this.getFileStorage(fileId);
    return fileStorage;
  }

  getPersistedStepId(fileId: string): string | null {
    const stepState = this.getStepState(fileId);
    return stepState?.selectedStepId ?? null;
  }

  setSelectedStepId(fileId: string, stepId?: string): void {
    if (stepId) {
      this.setStepState(fileId, {selectedStepId: stepId});
    } else {
      this.setStepState(fileId, undefined);
    }
  }

  setStepState(fileId: string, fileStepState: WorksheetStorageStateInterface | undefined): void {
    this.setFileStorage(fileId, fileStepState);
  }
}

const getWorksheetPersistentStorage = lazyInit<WorksheetPersistentStorage>(
  () => new WorksheetPersistentStorage()
);

export default getWorksheetPersistentStorage;
